/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */
import * as styled from 'styled-components';
import {theme, paddings} from 'components/shared/theme';

import loadingImage from 'assets/images/spinners/loading-icon-32x32.gif';

const {
  primaryBorderRadius,
  primaryFontSize,
  colors,
  dangerColor,
  spacing
} = theme;

export const Button = styled.default.button<{
  backgroundColor?: string;
  borderColor?: string;
  textColor?: string;
  disabled?: boolean;
}>`
  ${({backgroundColor, textColor, borderColor}) => styled.css`
    color: ${textColor || colors.white};
    background-color: ${backgroundColor || colors.white};
    border-color: ${borderColor || backgroundColor || colors.lightRed};
  `}
  ${({disabled}) => styled.css`
    opacity: ${disabled ? 0.8 : 1};
    cursor: ${disabled ? 'not-allowed' : 'pointer'};
  `}
  min-width: 120px;
  text-align: center;
  outline: none;
  vertical-align: middle;
  border-radius: ${primaryBorderRadius};
  padding: ${paddings.small} ${paddings.medium};
  font-size: ${primaryFontSize};
  transition: color .15s ease-in-out, background-color .15s ease-in-out;
`;

export const FilterButton = styled.default(Button)`
  font-weight: bolder;
  justify-self: center;
  margin: 0 ${spacing.xSmall};
  padding: ${paddings.small} ${paddings.xlarge};
`;

export const ConfirmButton = styled.default(Button)`
  margin-right: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const CancelButton = styled.default(ConfirmButton)``;

export const CustomButton = styled.default(Button)`
  background-color: ${dangerColor};
  border-color: ${dangerColor};
  color: ${colors.white};
  font-weight: bolder;
  justify-self: center;
  margin: 0.75rem;
  padding: ${paddings.small} ${paddings.xlarge};
  overflow: visible;
`;

export const LoadingIcon = styled.default.img.attrs(() => ({
  src: loadingImage,
  alt: 'loading...',
  className: 'testId-buttonLoader'
}))`
  float: left;
  width: 24px;
  margin-right: 5px;
`;